"use strict";

exports.__esModule = true;
exports.default = void 0;

var renderPage = function renderPage(ctx, node) {
  var _node$box = node.box,
      width = _node$box.width,
      height = _node$box.height;
  ctx.addPage({
    size: [width, height],
    margin: 0
  });
};

var _default = renderPage;
exports.default = _default;